export const productionDictionaries = {
  version: "1.0.0",
  industry: "production",
  companies: {
    galvo: {
      name: "Galvo",
      description: "Zakład galwanizacji",
      equipment: [
        "wanna galwaniczna",
        "wanna galwaniczna 3",
        "linia chromowania",
        "linia niklowania",
        "linia cynkowania",
        "suszarka",
        "myjka",
        "odgrzelnik",
        "zawiesiarka",
        "kadź",
        "kadź do odtłuszczania",
        "regeneracja",
        "pasywent",
        "stacja płukania",
        "wanna odtłuszczania",
        "prasa",
        "prasa 3",
        "powłoka chromowa",
        "powłoka niklowana",
        "detale",
        "pakowarka",
        "ładowarka",
        "paczkomat",
        "dysza",
        "sprzęgło"
      ],
      equipmentSynonyms: {
        "pakowarka": ["pakowaczka"],
        "wanna galwaniczna": ["wanna", "kąpiel", "kąpiel galwaniczna"],
        "wanna galwaniczna 3": ["wanna trzy", "wanna numer trzy"],
        "linia chromowania": ["chrom", "chromowanie"],
        "linia niklowania": ["nikiel", "niklowanie"],
        "linia cynkowania": ["cynk", "cynkowanie", "galwanizacja"],
        suszarka: ["suszenie", "tunel suszący"],
        "powłoka chromowa": ["powłoki chromowej", "powłoce chromowej"],
        "powłoka niklowana": ["powłoki niklowanej", "powłoce niklowanej"],
        detale: ["detali"]
      },
      processes: [
        "chromowanie",
        "niklowanie",
        "cynkowanie",
        "miedziowanie",
        "mosiądżowanie",
        "srebrzenie",
        "złocenie",
        "pasywacja",
        "odtłuszczanie",
        "trawienie",
        "płukanie",
        "suszenie"
      ],
      products: [
        "detal",
        "powłoka galwaniczna",
        "zabezpieczenie antykorozyjne",
        "klosz",
        "wspornik",
        "śruba",
        "nakrętka",
        "zawieszka",
        "element złączny",
        "blacha",
        "rura",
        "złącze"
      ],
      materials: [
        "chrom",
        "nikiel",
        "cynk",
        "miedź",
        "mosiądz",
        "srebro",
        "złoto",
        "kwas",
        "zasada",
        "elektrolit",
        "woda demi",
        "środek myjący"
      ],
      locations: [
        "hala",
        "hala galwaniczna",
        "hala przygotowania",
        "hala B",
        "magazyn chemii",
        "stanowisko odbioru",
        "suszarnia",
        "sortownia",
        "biuro laboratoryjne"
      ],
      locationSynonyms: {
        "hala przygotowania": ["hali przygotowania"],
        "hala B": ["hali B"]
      },
      failureTypes: [
        "brak powłoki",
        "plamy na powłoce",
        "przebarwienia",
        "nierówna powłoka",
        "pęcherze",
        "zacieki",
        "brak połysku",
        "pory",
        "pęknięcia",
        "zabrudzenie",
        "zaczadzenie",
        "przegrzanie kąpieli"
      ],
      actions: [
        "wymiana kąpieli",
        "regeneracja elektrolitu",
        "czyszczenie",
        "płukanie",
        "wymiana anod",
        "kalibracja",
        "konserwacja",
        "przegląd"
      ]
    },
    kosbud: {
      name: "KosBud",
      description: "Producent tynków, farb i deski elewacyjnej elastycznej",
      equipment: [
        "mieszalnik",
        "młyn",
        "młyn do farb",
        "ekstruder",
        "prasa",
        "suszarnia",
        "linia do tynków",
        "linia do farb",
        "pakowarka",
        "paletyzator",
        "silos",
        "silos z cementem",
        "przenośnik taśmowy",
        "homogenizator",
        "mieszadło dyspersyjne",
        "deska elewacyjna elastyczna",
        "worki z tynkiem",
        "ładowarka",
        "paczkomat",
        "dysza",
        "sprzęgło"
      ],
      equipmentSynonyms: {
        mieszalnik: ["mieszadło", "mikser"],
        młyn: ["mielarka"],
        "worki z tynkiem": ["workach z tynkiem"],
        suszarnia: ["suszarka", "tunel suszący"],
        pakowarka: ["pakowanie", "pakowaczka"],
        "linia do tynków": ["produkcja tynków"],
        "linia do farb": ["produkcja farb"]
      },
      processes: [
        "mieszanie",
        "mielenie",
        "ekstruzja",
        "suszenie",
        "granulacja",
        "pakowanie",
        "paletyzacja",
        "malowanie",
        "nakładanie",
        "dyspersja"
      ],
      products: [
        "tynk",
        "tynk zewnętrzny",
        "tynk wewnętrzny",
        "farba",
        "farba elewacyjna",
        "farba podkładowa",
        "grunt",
        "klej do styropianu",
        "deska elewacyjna elastyczna",
        "elewacja",
        "fasada",
        "łatka",
        "siatka"
      ],
      materials: [
        "cement",
        "wapno",
        "piasek",
        "gips",
        "polimer",
        "dyspersja",
        "pigment",
        "wypełniacz",
        "styropian",
        "wełna mineralna",
        "siatka z włókna szklanego",
        "żywica",
        "kruszywo",
        "woda"
      ],
      locations: [
        "hala",
        "hala produkcyjna tynków",
        "hala tynków",
        "hala farb",
        "linia",
        "linia deski elewacyjnej",
        "linia deski",
        "linia tynków",
        "magazyn surowców",
        "magazyn gotowych",
        "laboratorium",
        "rampa załadunkowa",
        "prasa"
      ],
      locationSynonyms: {
        "hala tynków": ["hali tynków"],
        "hala farb": ["hali farb"],
        "magazyn gotowych": ["magazynu gotowych"],
        "magazyn surowców": ["magazynu surowców"]
      },
      failureTypes: [
        "zbyt gęsta masa",
        "zbyt rzadka masa",
        "nierównomierne zabarwienie",
        "klastry",
        "grudki",
        "pęcherze",
        "pęknięcia",
        "wilgoć",
        "zanieczyszczenie",
        "zbyt wolne schnięcie",
        "zbyt szybkie schnięcie",
        "brak przyczepności"
      ],
      actions: [
        "dosyp surowca",
        "dodaj wody",
        "zmień proporcje",
        "wymień sito",
        "czyśczenie młyna",
        "kalibracja",
        "konserwacja",
        "przegląd",
        "kontrola partii"
      ]
    }
  },
  shared: {
    employees: [
      { canonical: "Marek", forms: ["Marek", "Marka", "Markowi", "Markiem", "Marku"] },
      { canonical: "Anna", forms: ["Anna", "Anny", "Annie", "Annę", "Anną", "Anno"] },
      { canonical: "Piotr", forms: ["Piotr", "Piotra", "Piotrowi", "Piotrem", "Piotrze"] },
      { canonical: "Kasia", forms: ["Kasia", "Kasi", "Kasią", "Kasię"] },
      { canonical: "Tomek", forms: ["Tomek", "Tomka", "Tomkowi", "Tomkiem", "Tomku"] },
      { canonical: "Łukasz", forms: ["Łukasz", "Łukasza", "Łukaszowi", "Łukaszem", "Łukaszu"] },
      { canonical: "Bartek", forms: ["Bartek", "Bartka", "Bartkowi", "Bartkiem", "Bartku"] },
      { canonical: "Agnieszka", forms: ["Agnieszka", "Agnieszki", "Agnieszce", "Agnieszkę", "Agnieszką"] },
      { canonical: "Wojtek", forms: ["Wojtek", "Wojtka", "Wojtkowi", "Wojtkiem", "Wojtku"] },
      { canonical: "Zbyszek", forms: ["Zbyszek", "Zbyszka", "Zbyszkowi", "Zbyszkiem", "Zbyszku"] }
    ],
    arrangementPatterns: [
      "ma zrobić",
      "ma wykonać",
      "ma dostarczyć",
      "ma przygotować",
      "ma sprawdzić",
      "ma naprawić",
      "ma zgłosić",
      "ma wymienić",
      "ma dopilnować",
      "ma ustalić",
      "muszę zrobić",
      "powinien zrobić",
      "trzeba zrobić"
    ],
    topics: [
      "awaria",
      "usterka",
      "nieobecność",
      "urlop",
      "BHP",
      "kontrola jakości",
      "ustalenia",
      "przekazanie zmiany",
      "szkolenie",
      "incydent",
      "produkcja",
      "opóźnienie",
      "wynik",
      "raport",
      "zamówienie",
      "magazyn",
      "przegląd",
      "dostawa",
      "konserwacja",
      "logistyka",
      "reklamacja",
      "wada jakości",
      "laboratorium"
    ],
    weekdays: [
      "poniedziałek",
      "wtorek",
      "środa",
      "czwartek",
      "piątek",
      "sobota",
      "niedziela"
    ],
    relativeDates: {
      dzisiaj: 0,
      dziś: 0,
      wczoraj: -1,
      jutro: 1,
      "w tym tygodniu": 0,
      "w przyszłym tygodniu": 7
    },
    greetings: ["dzień dobry", "cześć", "witam"]
  },
  wordVectors: {},
  trainingMeta: {
    generatedAt: "2026-08-14",
    source: "manual",
    nextStep: "fill word_vectors via embedding generation"
  }
} as const;
